/**
 * MaintenanceRoute - Wrapper that redirects to maintenance page when system is in maintenance mode
 * Allows: /login, /dashboard, /admin-panel
 * Blocks: All other routes for non-admin users
 */
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMaintenance } from '../context/MaintenanceContext';
import { AuthContext } from '../context/AuthContext';
import Maintenance from '../pages/Maintenance';

// Routes that are always allowed during maintenance
const ALLOWED_PATHS = ['/login', '/dashboard', '/admin-panel', '/onboarding'];

export default function MaintenanceRoute({ children }) {
  const { maintenanceMode, loading } = useMaintenance();
  const { user } = useContext(AuthContext);
  const location = useLocation();

  // Don't block while loading maintenance status
  if (loading) {
    return children;
  }

  // If not in maintenance mode, allow everything
  if (!maintenanceMode) {
    return children;
  }

  // Check if current path is allowed
  const currentPath = location.pathname.toLowerCase();
  const isAllowedPath = ALLOWED_PATHS.some(path => 
    currentPath === path || currentPath.startsWith(path + '/')
  );

  if (isAllowedPath) {
    return children;
  }

  // Admins can access everything even during maintenance
  const isAdmin = user?.role?.toLowerCase() === 'admin';
  if (isAdmin) {
    return children;
  }

  // Show maintenance page for blocked routes
  return <Maintenance />;
}
